export const CUSTOM_INTEREST = "insights.areaOfInterest.custom"
